import { GpxPoint } from './types';
import { GPXData } from '../types'; // Assuming GPXData is exported from src/types

/**
 * Converts the GPXData structure from the existing parser 
 * into an array of GpxPoint objects suitable for elevation processing.
 * 
 * @param gpxData - The GPXData object from parseGPX.
 * @returns An array of GpxPoint objects.
 */
export function adaptGpxDataToPoints(gpxData: GPXData): GpxPoint[] {
  if (!gpxData || !gpxData.coordinates) {
    return [];
  }

  return gpxData.coordinates.map(([lon, lat, ele]) => ({
    lat,
    lon,
    ele: ele !== undefined ? ele : undefined, // Keep elevation optional
    // Time information is not directly available in this coordinate structure,
    // It might be in gpxData.metadata.time for the whole track, or requires 
    // parsing individual <time> tags if needed later.
  }));
} 